module.exports = __webpack_public_path__ + "static/media/statistics-selected.dc47f3e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/statistics-selected.svg
// module id = 974
// module chunks = 0